import { render, staticRenderFns } from "./ActivityModalReport.vue?vue&type=template&id=65804e28&"
import script from "./ActivityModalReport.vue?vue&type=script&lang=js&"
export * from "./ActivityModalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports